import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import helpers from '../../helper';
import moment from 'moment';

export default function Footer() {
    const [services, setService] = useState([]);
    const [setting, SetSetting] = useState('');
    const [socialmedias, setSocialMedias] = useState([]);

    const [btnloader, setBtnloader] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState({ name: "", email: "", phone: "" });

    useEffect(() => {
        async function fetchService() {
            await axios.get(process.env.REACT_APP_API + 'api/products').then((response) => {
                setService(response.data.result.data);
            });
        }
        fetchService();
    }, [setService]);

    useEffect(() => {
        async function fetchSetting() {
            await axios.get(process.env.REACT_APP_API + 'api/setting').then((response) => {
                SetSetting(response.data.result);
            });
        }
        fetchSetting();
    }, [SetSetting]);

    useEffect(() => {
        async function getsocialmedia() {
            await axios.get(process.env.REACT_APP_API + 'api/socialmedia').then((response) => {
                setSocialMedias(response.data.result);
            });
        }
        getsocialmedia();
    }, [setSocialMedias]);

    async function FQuoteRequest(e) {
        e.preventDefault();
        setBtnloader(true);
        setError({ name: "", email: "", phone: "" });
        let callback = { name: name, email: email, phone: phone, product: 0 }
        await axios.post(process.env.REACT_APP_API + 'api/quoterequest', callback)
            .then((response) => {
                toast.success(response.data.message);
                setBtnloader(false);
                setName("");
                setEmail("");
                setPhone("");
            })
            .catch((errors) => {
                if (errors.response !== undefined) {
                    let rterror = errors.response.data.errors;
                    setError({
                        name: rterror.name,
                        email: rterror.email,
                        phone: rterror.phone
                    });
                    setBtnloader(false);
                }
            });
    }

    return (
        <>
            <footer className="ts">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-2">
                            <h3 className="h5 text-white text-u">Important Links</h3>
                            <ul className="links">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/products">Product</Link></li>
                                <li><Link to="/manufacturing">Manufacturing</Link></li>
                                <li><Link to="/clients">Clients</Link></li>
                                <li><Link to="/blogs">Blog</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-5">
                            <h3 className="h5 text-white text-u">Products</h3>
                            <div className="row">
                                <div className="col-md-12">
                                    <ul className="links">
                                        {
                                            services.map((service, se) =>
                                                <li key={se}><Link title={service.title} to={"/product/" + service.alias}>{service.title}</Link></li>

                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <h3 className="h5 text-white text-u">Help</h3>
                            <ul className="links">
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><Link to="/faq">FAQ</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                {/* <li><Link to="/terms-and-conditions">Terms of Conditions</Link></li> */}
                                <li><Link to="/careers">Career</Link></li>
                            </ul>
                        </div>
                        {
                            setting ?
                                <div className="col-lg-3">
                                    <h3 className="h5 text-white text-u">Customer Support</h3>
                                    <ul className="ConInfo">
                                        {
                                            setting.footer_contact_number ?
                                                <li>
                                                    <img src={require("../../assets/img/call-w.svg").default} alt="Call" width="42" height="42" />
                                                    <span>
                                                        {
                                                            helpers.helpers2(setting.footer_contact_number).map((phones, ph) =>
                                                                <a key={ph} href={"tel:" + phones} className="d-block">{phones}</a>
                                                            )
                                                        }

                                                    </span>
                                                </li>
                                                : ''
                                        }
                                        {
                                            setting.footer_email_address ?
                                                <li>
                                                    <img src={require("../../assets/img/mail-w.svg").default} alt="Mail" width="42" height="42" />
                                                    <span>
                                                        {
                                                            helpers.helpers2(setting.footer_email_address).map((emails, em) =>
                                                                <a key={em} href={"mailto:" + emails} className="d-block">{emails}</a>
                                                            )
                                                        }
                                                    </span>
                                                </li>
                                                : ''
                                        }
                                    </ul>
                                </div>
                                :

                                ''
                        }

                    </div>
                </div>
                <div className="fbottom mt-4">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-4 text-start">
                                <p><small>&#169; {moment().format('YYYY')} <strong className="text-white text-u">PES INSTALLATIONS</strong>. All Rights Reserved.</small></p>
                            </div>
                            <div className="col-md-4">
                                {
                                    socialmedias ?
                                        <>
                                            {
                                                socialmedias.length > 0 ?
                                                    <ul className="icons p-0 m-0">
                                                        {
                                                            socialmedias.map((socialmedia, sm) =>
                                                                <li key={sm}>
                                                                    {
                                                                        socialmedia.title === 'facebook' ?
                                                                            <a href={socialmedia.link} target="_blank" rel="noreferrer" title="Facebook"><img loading="lazy" src={require('../../assets/img/facebook-w.svg').default} alt={socialmedia.title} width="24" height="24" /></a>
                                                                            : ''
                                                                    }
                                                                    {
                                                                        socialmedia.title === 'twitter' ?
                                                                            <a href={socialmedia.link} target="_blank" rel="noreferrer" title="Twitter"><img loading="lazy" src={require('../../assets/img/twitter-w.svg').default} alt={socialmedia.title} width="24" height="24" /></a>
                                                                            : ''
                                                                    }
                                                                    {
                                                                        socialmedia.title === 'linkedin' ?
                                                                            <a href={socialmedia.link} target="_blank" rel="noreferrer" title="Linkedin"><img loading="lazy" src={require('../../assets/img/linkedin-w.svg').default} alt={socialmedia.title} width="24" height="24" /></a>
                                                                            : ''
                                                                    }
                                                                    {
                                                                        socialmedia.title === 'instagram' ?
                                                                            <a href={socialmedia.link} target="_blank" rel="noreferrer" title="Instagram"><img loading="lazy" src={require('../../assets/img/instagram-w.svg').default} alt={socialmedia.title} width="24" height="24" /></a>
                                                                            : ''
                                                                    }
                                                                    {
                                                                        socialmedia.title === 'youtube' ?
                                                                            <a href={socialmedia.link} target="_blank" rel="noreferrer" title="Youtube"><img loading="lazy" src={require('../../assets/img/youtube-w.svg').default} alt={socialmedia.title} width="24" height="24" /></a>
                                                                            : ''
                                                                    }
                                                                </li>
                                                            )
                                                        }
                                                        <li className="d-none d-lg-inline-block"><a href="https://api.whatsapp.com/send?phone=+919353075858&amp;text=Hi, I would like to get more information.." rel="noreferrer" target="_blank" title="Whatsapp"><img loading="lazy" src={require('../../assets/img/whatsapp-w.svg').default} alt="Whatsapp" width="24" height="24" /></a></li>
                                                        <li className="d-lg-none"><a href="whatsapp://send?text=Hi, I would like to get more information..!&amp;phone=+919353075858" target="_blank" rel="noreferrer" title="Whatsapp"><img loading="lazy" src={require('../../assets/img/whatsapp-w.svg').default} alt="Whatsapp" width="24" height="24" /></a></li>
                                                    </ul>
                                                    : ''
                                            }
                                        </>
                                        :
                                        ''
                                }

                            </div>
                            <div className="col-md-4 text-end">
                                <p><small>Made with &nbsp;<strong><span className="text-danger">&#10084;</span></strong>&nbsp; by <strong><a href="https://www.samwebstudio.com/" className="text-white" rel="noreferrer" target="_blank">SAM Web Studio</a></strong></small></p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <ToastContainer />
            <div className="modal fade PopupM" id="QEnForm" tabIndex="-1" aria-labelledby="CareerFormLabel" aria-hidden="true">
                <div className="modal-dialog modal-md">
                    <form className="modal-content Quotefrm" onSubmit={FQuoteRequest}>
                        <div className="modal-header border-0 d-none">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body pt-5 px-md-5">
                            <h3 className="fw-bold text-center h4 thm">Request a Quote</h3>
                            <p>Fill out the form below and apply for quotation.
                            </p>
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} id="name" placeholder="Name" />
                                        <label htmlFor="name" className="form-label">Name<span className="text-danger">*</span></label>
                                        {error.name ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.name}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" />
                                        <label htmlFor="email" className="form-label">Email Address<span className="text-danger">*</span></label>
                                        {error.email ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.email}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-12">
                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} id="mobile" placeholder="Contact Number" />
                                        <label htmlFor="mobile" className="form-label">Contact Number<span className="text-danger">*</span></label>
                                        {error.phone ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.phone}</span> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer pt-4 border-top pb-5 d-block text-center">
                            {
                                btnloader ?
                                    <button type="button" className="btn btn-thm disabled"><FontAwesomeIcon icon={faSpinner} className="fa-spin me-1" /> Loading...</button>
                                    :
                                    <button className="btn btn-thm">Submit Application</button>
                            }
                            <button type="button" className="btn btn-thm1" data-bs-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
